var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 22.75C7.71996 22.75 3.45996 18.49 3.45996 13.25C3.45996 8.01 7.71996 3.75 12.96 3.75C18.2 3.75 22.46 8.01 22.46 13.25C22.46 18.49 18.2 22.75 12.96 22.75ZM12.96 5.25C8.54996 5.25 4.95996 8.84 4.95996 13.25C4.95996 17.66 8.54996 21.25 12.96 21.25C17.37 21.25 20.96 17.66 20.96 13.25C20.96 8.84 17.37 5.25 12.96 5.25Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 13.75C12.55 13.75 12.21 13.41 12.21 13V8C12.21 7.59 12.55 7.25 12.96 7.25C13.37 7.25 13.71 7.59 13.71 8V13C13.71 13.41 13.37 13.75 12.96 13.75Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 2.75H9.95996C9.54996 2.75 9.20996 2.41 9.20996 2C9.20996 1.59 9.54996 1.25 9.95996 1.25H15.96C16.37 1.25 16.71 1.59 16.71 2C16.71 2.41 16.37 2.75 15.96 2.75Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.3971efe1bbd764571db620c7f9e94e52.svg";
export { ForwardRef as ReactComponent };